import { contentBase as contentBaseSchema } from './content';
import { z } from 'zod';
import { metadata } from './helpers';

export const injuryTypeContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    injuries: z.array(
      z.object({
        title: z.string(),
        content: z.string(),
        image: z.string(),
      })
    ),
  }),
});

export const contentTypeInjuryTypeSchema = contentBaseSchema.extend({
  content: injuryTypeContentSchema,
});

export type ContentTypeInjuryTypeContentInput = z.infer<typeof contentTypeInjuryTypeSchema>;
